import { render, staticRenderFns } from "./PDPRiverContent.vue?vue&type=template&id=689a6580&scoped=true"
import script from "./PDPRiverContent.vue?vue&type=script&lang=js"
export * from "./PDPRiverContent.vue?vue&type=script&lang=js"
import style0 from "./PDPRiverContent.vue?vue&type=style&index=0&id=689a6580&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689a6580",
  null
  
)

export default component.exports